import { Component, ViewChild, ElementRef, OnInit, HostListener } from '@angular/core';
import * as bootstrap from 'bootstrap';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { LoginComponent } from '../login/login.component';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {
    faGoogle = faGoogle;
    clientUrlName: any = '';
    userGroupName: any = '';

    @ViewChild('signUpModal') signUpModal!: ElementRef; // Reference to the modal
    @ViewChild(LoginComponent) logInModalInstance!: LoginComponent;
    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private authService: AuthService,
        private commonServiceService: CommonServiceService,
    ) {
        // this.clientUrlName = this.route.snapshot.params.clientUrlName;
        // this.userGroupName = this.route.snapshot.params.userGroupName;
    }
    registerForm: FormGroup = this.fb.group(
        {
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            emailAddress: ['', [Validators.required, Validators.email]],
            currentPassword: ['', [Validators.required, this.customPasswordValidator]],
            confirmPassword: ['', [Validators.required, this.customPasswordValidator]],
        },
        // {
        //     validator: this.customValidator.MatchPassword('currentPassword', 'confirmPassword'),
        // }
    );
    get regForm() {
        return this.registerForm.controls;
    }
    validateFirstName() {
        if (this.registerForm.value.firstName.trim() === '') {
            this.registerForm.get('firstName')?.setErrors({ spaceOnly: true });
        }
    }
    validateLastName() {
        if (this.registerForm.value.lastName.trim() === '') {
            this.registerForm.get('lastName')?.setErrors({ spaceOnly: true });
        }
    }
    ngOnInit() {
        // Access the LoginModalComponent after initialization
        // this.logInModalInstance = new LoginComponent();
        this.registerForm = this.fb.group(
            {
                firstName: ['', Validators.required],
                lastName: ['', Validators.required],
                emailAddress: ['', [Validators.required, Validators.email]],
                currentPassword: ['', [Validators.required, this.customPasswordValidator]],
                confirmPassword: ['', [Validators.required, this.customPasswordValidator]],
            },
            // {
            //     validator: this.customValidator.MatchPassword('currentPassword', 'confirmPassword'),
            // }
        );
        this.pwdDoNotMatch = false;
        this.isSignUp = false;
        this.isCheckingMail = false;
        this.invalidEmail = false;
        this.isEmailRegistred = false;
        this.submitted = false;
    }
    pwdDoNotMatch: boolean = false;
    checkPassword() {
        if (!this.registerForm.get('currentPassword')?.hasError('invalidPassword') && !this.registerForm.get('confirmPassword')?.hasError('invalidPassword')) {
            this.pwdDoNotMatch = this.registerForm.value.currentPassword !== this.registerForm.value.confirmPassword;
        }
    }
    customPasswordValidator(control: any) {
        // debugger;
        const value = control.value;

        // Define criteria for password validation
        const lowercaseRegex = /[a-z]/;
        const uppercaseRegex = /[A-Z]/;
        const numberRegex = /[0-9]/;
        const symbolRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/; // Add more symbols if needed

        let criteriaMet = 0;
        if (lowercaseRegex.test(value)) {
            criteriaMet++;
        }
        if (uppercaseRegex.test(value)) {
            criteriaMet++;
        }
        if (numberRegex.test(value)) {
            criteriaMet++;
        }
        if (symbolRegex.test(value)) {
            criteriaMet++;
        }
        let validPassword = false;
        if (value.trim().length >= 8 && value.trim().length <= 64 && criteriaMet >= 3) {
            validPassword = true;
        }
        // Check if at least 3 criteria are met
        return validPassword ? null : { invalidPassword: true };
    }
    openSignUpModal() {
        const modalElement = this.signUpModal.nativeElement;
        const modalInstance = new bootstrap.Modal(modalElement);
        this.ngOnInit();
        modalInstance.show();
    }
    isSignUp: boolean = false;
    createGyanUser() {}
    onSubmit() {
        if (this.registerForm.valid && !this.pwdDoNotMatch && !this.isEmailRegistred && !this.isCheckingMail) {
            const signUpDetails = {
                firstName: this.registerForm.value.firstName,
                lastName: this.registerForm.value.lastName,
                email: this.registerForm.value.emailAddress,
                password: this.registerForm.value.currentPassword,
                clientUrlName: 'Gyan',
                userGroupUrlName: 'GyanUsers',
                personId: this.authService.getPersonId(),
                clientId: 0,
                userGroupId: 0,
                userId: this.authService.getUserId(),
            };
            // this.spinnerComponent.showSpinner();
            this.isSignUp = true;

            this.authService.signUp(signUpDetails).subscribe(
                (res) => {
                    this.isSignUp = true;
                    console.log('res');
                    console.log(res);
                },
                (err: HttpErrorResponse) => {
                    // console.log('err');
                    // console.log(err);
                    // if (err.error.message == 'Email already registered') {
                    //     this.spinnerComponent.hideSpinner();
                    //     this.isEmailRegistred = true;
                    // }
                    // this.spinnerComponent.hideSpinner();
                },
            );
        }
    }

    @HostListener('window:focusin', ['$event'])
    onFocus(event: FocusEvent): void {
        if (this.isInputElement(event.target)) {
            document.body.style.position = 'fixed';
            document.body.style.top = '-1px';
        }
    }

    @HostListener('window:focusout', ['$event'])
    onBlur(event: FocusEvent): void {
        if (this.isInputElement(event.target)) {
            document.body.style.top = '';
            window.scrollTo(0, 0);
        }
    }

    private isInputElement(target: EventTarget | null): target is HTMLInputElement | HTMLTextAreaElement {
        return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement;
    }

    closeSignUpModal() {
        const modalElement = this.signUpModal.nativeElement;
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide(); // Call hide() on the existing modal instance if it exists
        }

        this.commonServiceService.setScrollToTop(true);
    }

    get registerFormControl() {
        return this.registerForm.controls;
    }
    isCheckingMail = false;
    invalidEmail = false;
    isEmailRegistred = false;
    submitted = false;
    emailIdInputBox() {
        this.isCheckingMail = true;
        this.invalidEmail = false;
        this.isEmailRegistred = false;
        if (this.registerForm.value.emailAddress.trim() === '') {
            this.registerForm.get('emailAddress')?.setErrors({ required: true });
        } else {
            if (this.registerForm.get('emailAddress')?.hasError('email')) {
                this.invalidEmail = true;
            } else {
                this.invalidEmail = false;
                this.authService.isEmailExists(this.registerForm.value.emailAddress).subscribe(
                    (res) => {
                        this.isCheckingMail = false;
                        if (res.toString() === 'true') {
                            //this.registerForm.get('emailAddress')?.setErrors({ alreadyExists: true });
                            this.isEmailRegistred = true;
                        } else {
                            //this.registerForm.get('emailAddress')?.setErrors({ alreadyExists: false });
                            this.isEmailRegistred = false;
                        }
                    },
                    (err: HttpErrorResponse) => {},
                );
            }
        }
    }
}
